import { ITEM_BOOLEAN_FILTERS } from '@/lib/api/common/itemTableFilters';
import {
  LOCATION_BOOLEAN_FILTERS,
  LOCATION_FILTER_KEYS,
  LOCATION_PICKLIST_FILTERS,
} from '@/lib/api/common/locationTableFilters';
import {
  RESOURCE_BOOLEAN_FILTERS,
  RESOURCE_FILTER_KEYS,
  RESOURCE_PICKLIST_FILTERS,
} from '@/lib/api/common/resourceTableFilters';
import { TEAMS_PICKLIST_FILTERS } from '@/lib/api/common/teamsTableFilters';
import {
  TEAM_BOOLEAN_FILTERS,
  TEAM_FILTER_KEYS,
  TEAM_PICKLIST_FILTERS,
} from '@/lib/api/common/teamTableFilters';
import type { DatetimeFilterKeys, PicklistFilterKeys } from '@/lib/api/types/itemFilters';

export const INSIGHTS_PICKLIST_FILTERS = [
  'teamId',
  'statusId',
  'itemTypeId',
] as const satisfies readonly PicklistFilterKeys[];

export const INSIGHTS_DATE_FILTERS = [
  'plannedStartDateTime',
  'plannedFinishDateTime',
] as const satisfies readonly DatetimeFilterKeys[];

export const PICKLIST_FILTERS = [
  ...INSIGHTS_PICKLIST_FILTERS,
  ...LOCATION_PICKLIST_FILTERS,
  ...RESOURCE_PICKLIST_FILTERS,
  ...TEAMS_PICKLIST_FILTERS,
  ...TEAM_PICKLIST_FILTERS,
] as const;

export const DATE_FILTERS = [...INSIGHTS_DATE_FILTERS] as const;

export const BOOLEAN_FILTERS = [
  ...ITEM_BOOLEAN_FILTERS,
  ...LOCATION_BOOLEAN_FILTERS,
  ...RESOURCE_BOOLEAN_FILTERS,
  ...TEAM_BOOLEAN_FILTERS,
] as const;

export const INSIGHTS_FILTER_KEYS = [
  ...INSIGHTS_PICKLIST_FILTERS,
  ...INSIGHTS_DATE_FILTERS,
] as const satisfies readonly [string, ...string[]];

export const FILTER_KEYS = [
  ...INSIGHTS_FILTER_KEYS,
  ...LOCATION_FILTER_KEYS,
  ...RESOURCE_FILTER_KEYS,
  ...TEAMS_PICKLIST_FILTERS,
  ...TEAM_FILTER_KEYS,
] as const satisfies readonly [string, ...string[]];

export type InsightsFilterKey = (typeof INSIGHTS_FILTER_KEYS)[number];
export type ResourceFilterKey = (typeof RESOURCE_FILTER_KEYS)[number];
export type TeamsFilterKey = (typeof TEAMS_PICKLIST_FILTERS)[number];
export type TeamFilterKey = (typeof TEAM_FILTER_KEYS)[number];
export type LocationFilterKey = (typeof LOCATION_FILTER_KEYS)[number];
export type CompactFilterKey = (typeof FILTER_KEYS)[number];
